
import Tooltip from '05-ui-kit/lib/Tooltip';
import { computed, ref } from '@vue/composition-api';
import { shallowRef } from '@nuxtjs/composition-api';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import type { Comment } from '~/type/Comment';
import { useAuthStore } from '~/store/modal/auth';
import TextareaButton from '~/components/review-component/TextareaButton/TextareaButton.vue';
import { useUserStore } from '~/store/user';
const __sfc_main = {};
__sfc_main.props = {
  id: {
    key: "id",
    required: true,
    type: String
  },
  productId: {
    key: "productId",
    required: true,
    type: Number
  },
  name: {
    key: "name",
    required: false,
    type: String
  },
  placeholder: {
    key: "placeholder",
    required: false,
    type: String
  },
  height: {
    key: "height",
    required: false,
    type: Number
  },
  borderRadius: {
    key: "borderRadius",
    required: false,
    type: String
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const observer = shallowRef();
  const {
    userAuth,
    name: userName
  } = useUserStore();
  const {
    enable: enableAuthModal
  } = useAuthStore();
  const isUserAuth = computed(() => userAuth);
  const data = ref<Comment>({
    id: props.id,
    productId: props.productId,
    name: userName,
    text: ''
  });
  function onClick() {
    observer.value.validateWithInfo().then(({
      isValid
    }: {
      isValid: boolean;
    }) => {
      isValid ? send() : Tooltip({
        type: 'error',
        title: 'Заполните поле',
        description: '',
        mobileOffset: [5, 5, 63, 5]
      });
    });
  }
  function send() {
    if (isUserAuth.value) {
      emit('click', data.value);
    } else {
      enableAuthModal({
        onComplete: () => emit('click', data.value)
      });
    }
  }
  return {
    observer,
    data,
    onClick
  };
};
__sfc_main.components = Object.assign({
  ValidationObserver,
  ValidationProvider,
  TextareaButton
}, __sfc_main.components);
export default __sfc_main;
